import { render } from "./UnboxItemElement.vue?vue&type=template&id=412b4493&scoped=true"
import script from "./UnboxItemElement.vue?vue&type=script&lang=js"
export * from "./UnboxItemElement.vue?vue&type=script&lang=js"

import "./UnboxItemElement.vue?vue&type=style&index=0&id=412b4493&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412b4493"]])

export default __exports__